import React, { useEffect, useRef, useState } from "react";
import { all_routes } from "../../router/all_routes";
import { Link } from "react-router-dom";
import Table from "../../../core/common/dataTable";
import ImageWithBasePath from "../../../core/common/imageWithBasePath";
import PredefinedDateRanges from "../../../core/common/datePicker";
import { DatePicker } from "antd";
import CommonSelect from "../../../core/common/commonSelect";
import CollapseHeader from "../../../core/common/collapse-header/collapse-header";
import api from "../../../services/api";
import Loader from "../../../core/common/loader";
import { showBasicAlert } from "../../../core/common/useAlert";
import EditEmployee from "./edit_empolyee_modal";
import DeleteModal from "../../../core/modals/deleteModal";
import { jsPDF } from "jspdf";
import "jspdf-autotable";
import * as XLSX from "xlsx";
import UploadModal from "../../../core/modals/uploadModal";
import ViewDocumentsModal from "../../../core/modals/ViewDocumentModal";
import axios from "axios";
import { useSelector } from "react-redux";
import EditCredentialsModal from "../../../core/modals/EditCredentialsModal";
import ToggleLoginModal from "../../../core/modals/ToggleLoginModal";
import moment from "moment";
import dayjs from "dayjs";
import BulkDocumentsModal from "../../../core/modals/BulkDocumentsModal";
import EmployeeFilterPanel, { EmployeeFilters } from "./EmployeeFilterPanel";

type PasswordField = "password" | "confirmPassword";

interface FilterState {
  companyType: string | null;
  companyId: number | null;
  department: string | null;
  designation: string | null;
}

const EmployeeList = () => {
  const salutation = [
    { value: "Mr.", label: "Mr." },
    { value: "Mrs.", label: "Mrs." },
    { value: "Ms.", label: "Ms." },
    { value: "Dr.", label: "Dr." },
  ];

  const gender = [
    { value: "M", label: "Male" },
    { value: "F", label: "Female" },
    { value: "O", label: "Other" },
  ];

  const workFromOptions = [
    { value: 0, label: "Work from Home" },
    { value: 1, label: "Work from Office" },
  ];

  const biometricOptions = [
    { value: 0, label: "Disabled" },
    { value: 1, label: "Enabled" },
  ];

  const signature = localStorage.getItem("signature");
  const today = dayjs();

  useEffect(() => {
    const fetchDashboardData = async () => {
      try {
        await updateUI();
      } catch (err) {
        console.error("Error fetching dashboard data:", err);
      }
    };

    fetchDashboardData();
  }, []);
  const fileInputRef = useRef<HTMLInputElement>(null);
  const [isLoading, setIsLoading] = useState(false);
  const [getDepartmanet, setgetDepartmanet] = useState<any[]>([]);
  const [getDesignation, setgetDesignation] = useState<any[]>([]);
  const [getReportingOfficer, setgetReportingOfficer] = useState<any[]>([]);
  const [getAllCompanyList, setgetAllCompanyList] = useState<any[]>([]);
  const [CountryCode, setCountryCode] = useState<any[]>([]);
  const [selectedFile, setSelectedFile] = useState<File | null>(null);
  const [uploading, setUploading] = useState(false);
  const [isImageLoading, setIsImageLoading] = useState(false);
  const [selectedUserInfo, setSelectedUserInfo] = useState<any>(null);
  const [selectedUserData, setSelectedUserData] = useState<any>(null);
  const [selectedCredentialsUser, setSelectedCredentialsUser] =
    useState<any>(null);
  const [providerEmailCredentials, setProviderEmailCredentials] =
    useState<any>(null);
  const [editCredentialsForm, setEditCredentialsForm] = useState<{
    provider: string;
    email: string;
    password: string;
    company_type: string;
    company_id: number | string;
    user_id: number | string;
    id?: number | string; // `?` makes it optional
  }>({
    provider: "",
    email: "",
    password: "",
    company_type: "",
    company_id: "", // or a default value like 0
    user_id: "",
  });
  const [documentType, setDocumentType] = useState("");
  const user = useSelector((state: any) => state.user.user);
  const [data, setData] = useState<any[]>([]);
  const [filteredData, setFilteredData] = useState<any[]>([]);
  const [departmentFilter, setDepartmentFilter] = useState<string | null>(null);

  const [bulkUploadFilters, setBulkUploadFilters] = useState<FilterState>({
    companyType: null,
    companyId: null,
    department: null,
    designation: null,
  });
  const [selectedDepartmentKey, setSelectedDepartmentKey] = useState<string | number>("");
  const [filteredEmployeesFromModal, setFilteredEmployeesFromModal] = useState<
    any[]
  >([]);
  const [showBulkViewModal, setShowBulkViewModal] = useState(false);
  const [isFilterPanelOpen, setIsFilterPanelOpen] = useState(false);
  const [filters, setFilters] = useState<EmployeeFilters>({
    status: "Active",
    department: "All Departments",
    designation: "All Designations",
    sortBy: "Last 7 Days",
    joiningDate: null,
    createdDate: null,
    company: null,
    gender: "All Genders"
  });

  const handleFilteredEmployeesChange = (filteredEmployees: any[]) => {
    setFilteredEmployeesFromModal(filteredEmployees);

    if (filteredEmployees.length > 0) {
      const employeeKeys = filteredEmployees.map((emp: any) => emp.key);
      // setBulkUploadSelectedEmployees(employeeKeys);
      setSelectedEmployeeKeys(employeeKeys);
    }
  };

  const fetchReportingOfficer = async (companyId: any, companyType: any) => {
    setIsLoading(true);
    companyType = companyType.split("-")[1]?.trim();
    const [getReportingOfficer] = await Promise.all([
      api.post("userService/getReportingOfficer", {
        signature,
        companyId,
        companyType,
      }),
    ]);
    setgetReportingOfficer(getReportingOfficer.data.data.data);
    setIsLoading(false);
  };

  const updateUI = async () => {
    setIsLoading(true);
    try {
      const [
        getDepartment,
        getDesignation,
        countryResponse,
        getAllCompanyList,
        getEmployeesListDatas,
        getProviderEmailCredentials,
      ] = await Promise.all([
        api.post("userService/getDepartment", { signature }),
        api.post("userService/getDesignation", { signature }),
        api.post("userService/getCountry", { signature }),
        api.post("userService/getAllCompanyList", { signature }),
        api.post("userService/getEmployeesListData", { signature }),
        api.post("mailService/getProviderEmailCredentials", { signature }),
      ]);

      setgetDepartmanet(getDepartment.data.data.data);
      setgetDesignation(getDesignation.data.data.data);
      setCountryCode(countryResponse.data.data);
      setgetAllCompanyList(getAllCompanyList.data.data.data);

      const allEmployees = getEmployeesListDatas.data.data.data.allUsers;
      setData(allEmployees);

      const companiesData = getAllCompanyList.data.data.data;
      if (companiesData.length > 0) {
        const defaultCompany = {
          id: companiesData[0].id,
          name: companiesData[0].name,
          type: companiesData[0].type
        };

        setFilters(prev => ({
          ...prev,
          company: defaultCompany
        }));

        setCompanyName(defaultCompany);

        const filtered = allEmployees.filter(
          (item: any) => item.CompanyName === defaultCompany.name
        );
        setFilteredData(filtered);
      } else {
        setFilteredData(allEmployees);
      }
      if (!companyName && getAllCompanyList.data.data.data.length > 0) {
        const defaultCompany = getAllCompanyList.data.data.data[0];
        setCompanyName({
          id: defaultCompany.id,
          name: defaultCompany.name,
          type: defaultCompany.type,
        });
        await fetchReportingOfficer(
          defaultCompany.id,
          defaultCompany.name + "-" + defaultCompany.type
        );
        const filtered = allEmployees.filter(
          (item: any) => item.CompanyName === defaultCompany.name
        );
        setFilteredData(filtered);
      } else if (companyName) {
        const filtered = allEmployees.filter(
          (item: any) => item.CompanyName === companyName.name
        );
        setFilteredData(filtered);
      } else {
        setFilteredData(allEmployees);
      }

      const providerList = getProviderEmailCredentials?.data?.data?.data || [];
      const filteredData = providerList.filter(
        (item: any) => item.user_id !== null && item.provider !== null
      );
      setProviderEmailCredentials(filteredData);

      if (statusFilter == null) {
        setStatusFilter("Active");
      }
    } catch (error) {
      console.error("Error in updateUI:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleCompanySelect = (selectedOption: any) => {
    if (!selectedOption || !selectedOption.value) return;

    try {
      const [id, type] = selectedOption.value.split("-");
      const companyId = parseInt(id);

      const company = getAllCompanyList.find(c =>
        c.id === companyId &&
        c.type === type
      );

      if (company) {
        setCompanyName({
          id: company.id,
          name: company.name,
          type: company.type
        });

        setFilters(prev => ({
          ...prev,
          company: {
            id: company.id,
            name: company.name,
            type: company.type
          }
        }));

        fetchReportingOfficer(company.id, `${company.name}-${company.type}`);

        setCompanyKey(prev => prev + 1);

        if (data.length > 0) {
          applyFilters(data);
        }
      } else {
        console.error("Company not found for ID:", companyId, "and type:", type);
      }
    } catch (error) {
      console.error("Error handling company selection:", error);
    }
  };

  const fetchUpdatedRecords = async () => {
    setIsLoading(true);
    try {
      const [getEmployeesListDatas] = await Promise.all([
        api.post("userService/getEmployeesListData", { signature }),
      ]);

      const allEmployees = getEmployeesListDatas.data.data.data.allUsers;
      setData(allEmployees);

      applyFilters(allEmployees);
    } catch (error) {
      console.error("Error fetching updated records:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const applyFilters = (employees: any[]) => {
    let filtered = employees;

    if (filters.company && filters.company.name) {
      filtered = filtered.filter(
        (item: any) => item.CompanyName === filters.company?.name
      );
    }

    if (filters.status !== "All") {
      filtered = filtered.filter((item: any) => item.Status === filters.status);
    }

    // Apply gender filter
    if (filters.gender !== "All Genders") {
      filtered = filtered.filter(
        (item: any) => item.Gender === filters.gender
      );
    }

    if (filters.department !== "All Departments") {
      filtered = filtered.filter(
        (item: any) => item.Department === filters.department
      );
    }

    // Apply designation filter
    if (filters.designation !== "All Designations") {
      filtered = filtered.filter(
        (item: any) => item.Designation === filters.designation
      );
    }

    // Apply joining date filter
    if (filters.joiningDate?.start && filters.joiningDate?.end) {
      filtered = filtered.filter((item: any) => {
        if (!item.JoiningDate) return false;

        try {
          const [day, month, year] = item.JoiningDate.split("-");
          const joiningDate = new Date(Number(year), Number(month) - 1, Number(day));

          const startDate = new Date(filters.joiningDate!.start!);
          const endDate = new Date(filters.joiningDate!.end!);

          joiningDate.setHours(0, 0, 0, 0);
          startDate.setHours(0, 0, 0, 0);
          endDate.setHours(23, 59, 59, 999);

          return joiningDate >= startDate && joiningDate <= endDate;
        } catch (error) {
          console.error("Error parsing date:", item.JoiningDate, error);
          return false;
        }
      });
    }

    // Apply created date filter
    if (filters.createdDate?.start && filters.createdDate?.end) {
      filtered = filtered.filter((item: any) => {
        if (!item.CreatedDate) return false;

        try {
          const createdDate = new Date(item.CreatedDate);
          const startDate = new Date(filters.createdDate!.start!);
          const endDate = new Date(filters.createdDate!.end!);

          createdDate.setHours(0, 0, 0, 0);
          startDate.setHours(0, 0, 0, 0);
          endDate.setHours(23, 59, 59, 999);

          return createdDate >= startDate && createdDate <= endDate;
        } catch (error) {
          console.error("Error parsing date:", item.CreatedDate, error);
          return false;
        }
      });
    }

    filtered = sortData(filtered, filters.sortBy);

    setFilteredData(filtered);
  };

  const sortData = (dataToSort: any[], sortBy: string) => {
    return [...dataToSort].sort((a: any, b: any) => {
      switch (sortBy) {
        case "Recently Added":
          return (
            new Date(b.JoiningDate).getTime() -
            new Date(a.JoiningDate).getTime()
          );
        case "Ascending":
          return a.Name.localeCompare(b.Name);
        case "Descending":
          return b.Name.localeCompare(a.Name);
        case "Last Month":
          const oneMonthAgo = new Date();
          oneMonthAgo.setMonth(oneMonthAgo.getMonth() - 1);
          const lastMonthCreatedDate =
            new Date(b.JoiningDate).getTime() -
            new Date(a.JoiningDate).getTime();

          if (
            new Date(b.JoiningDate) >= oneMonthAgo &&
            new Date(a.JoiningDate) >= oneMonthAgo
          ) {
            return lastMonthCreatedDate;
          } else {
            return 0;
          }
        case "Last 7 Days":
          const sevenDaysAgo = new Date();
          sevenDaysAgo.setDate(sevenDaysAgo.getDate() - 7);
          const last7DaysCreatedDate =
            new Date(b.JoiningDate).getTime() -
            new Date(a.JoiningDate).getTime();

          if (
            new Date(b.JoiningDate) >= sevenDaysAgo &&
            new Date(a.JoiningDate) >= sevenDaysAgo
          ) {
            return last7DaysCreatedDate;
          } else {
            return 0;
          }
        default:
          return (
            new Date(b.JoiningDate).getTime() -
            new Date(a.JoiningDate).getTime()
          );
      }
    });
  };



  const [responsibilityInput, setResponsibilityInput] = useState("");
  var initialAddEmployyeFormData = {
    signature: signature,
    salutation: "",
    firstName: "",
    lastName: "",
    gender: "",
    dob: null,
    joiningDate: null,
    dol: null,
    username: "",
    email: "",
    password: "",
    countryCode: "",
    phoneNumber: "",
    companyId: "",
    company: "Select Company",
    department: getDepartmanet?.[0]?.Department || "",
    departmentKey: "",
    designation: getDesignation?.[0]?.Designation || "",
    reportingOfficer: 0,
    designationKey: "",
    userType: "",
    departmentAccess: "",
    profileUrl: "",
    essl_id: "",
    responsibilities: [],
    official_phone_code: "",
    official_mobile_no: "",
    emp_id: "",
    is_work_from: null,
    is_biometric_enable: null,
  };
  const [isUploadingImage, setIsUploadingImage] = useState(false);
  const [imagePreview, setImagePreview] = useState<any | null>(null);
  const [companyKey, setCompanyKey] = useState(0);
  const [companyName, setCompanyName] = useState<{ id: number | null, name: string, type: string } | null>(null);


  const [formDataAddEmployee, setformDataAddEmployee] = useState(
    initialAddEmployyeFormData
  );

  const handleDocumentTypeChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setDocumentType(e.target.value);
  };

  const handleUpload = async (file: File) => {
    if (!documentType.trim()) {
      showBasicAlert("Document Type is required.");
      return;
    }

    setUploading(true);

    // Check if this is a "bulk-like" document (based on naming or context)
    const isBulkLikeDocument = documentType.includes("Policy") ||
      documentType.includes("Handbook") ||
      documentType.includes("Guideline") ||
      documentType.includes("Manual");

    try {
      if (isBulkLikeDocument && selectedUserInfo?.companyId && selectedUserInfo?.companyType) {
        // Use rule-based upload for official/bulk-like documents
        const formData = new FormData();
        formData.append("file", file);
        formData.append("name", file.name);
        formData.append("document_type", documentType);
        formData.append("rule_type", "all_company_users");
        formData.append("access_type", "view");
        formData.append("signature", signature || "");

        const response = await api.post("driveService/uploadBulkDocumentWithRule", formData);
        const result = response.data?.message?.[0];

        if (result?.status) {
          showBasicAlert("Official document uploaded successfully! Available to all company users.");
          setSelectedFile(null);
          setDocumentType("");
        }
      } else {
        // Original individual upload logic
        const formData = new FormData();
        formData.append("file", file);
        formData.append("name", file.name);
        formData.append("type", "2");
        formData.append("mime_type", file.type || "text/plain");
        formData.append("size", file.size.toString());
        formData.append("status", "1");
        formData.append("document_type", documentType);
        formData.append("upload_source_type", JSON.stringify(true));
        formData.append("signature", signature || "");

        const response = await api.post("driveService/addDriveItem", formData);
        const result = response.data?.message?.[0];

        if (result?.status) {
          await handleShare(selectedUserInfo.key, result?.data?.id);
          setSelectedFile(null);
          setDocumentType("");
        }
      }
    } catch (error: any) {
      console.error("Upload error:", error);
      showBasicAlert(
        error?.response?.data?.message?.[0]?.msg || "Upload failed."
      );
    } finally {
      setUploading(false);
    }
  };


  const handleFileUpload = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.files && e.target.files.length > 0) {
      const file = e.target.files[0];
      setSelectedFile(file);
    }
  };

  const handleUploadModal = async (record: any) => {
    setSelectedUserInfo(record);
  };

  const handleModalClose = () => {
    setSelectedFile(null);
    setDocumentType("");
  };

  const uploadSelectedFile = async () => {
    if (!selectedFile) return;
    await handleUpload(selectedFile);
  };

  const handleShare = async (userId: any, fileId: any) => {
    const data = {
      signature,
      file_id: fileId,
      users: [
        {
          user_id: userId,
          access_type: "view",
        },
      ],
    };

    const response = await api.post(
      "driveService/shareFileWithPermissions",
      data
    );

    if (response?.data?.message?.[0]?.status) {
      showBasicAlert("File shared successfully!");
    } else {
      showBasicAlert("Failed to share the file.");
    }
  };

  const handleViewDocuments = async (record: any) => {
    setSelectedUserInfo({
      companyId: record.CompanyId,
      companyType: record.CompanyType,
      userId: record.key,
    });
    try {
      const dataToSend = {
        signature,
        company_id: record.CompanyId,
        company_type: record.CompanyType,
        user_id: record.key,
      };
      const response = await api.post(
        "driveService/getOfficialDocumentsByUserId",
        dataToSend
      );
      const message = response?.data?.data?.data;

      setSelectedUserData(message);
    } catch (err: any) {
      if (err.response) {
        console.error(
          "Error fetching quick access files:",
          err.response.data?.message?.[0]?.msg || "Unknown server error"
        );
      } else if (err.request) {
        console.error("No response received:", err.request);
      } else {
        console.error("Request error:", err.message);
      }
    }
  };

  const handleFileChange = async (e: any) => {
    const selectedFile = e.target.files[0];

    if (!selectedFile || !selectedFile.type.startsWith("image/")) {
      showBasicAlert("Please select a valid image file.");
      return;
    }

    // Set uploading state
    setIsUploadingImage(true);

    const result = await uploadFileToCloudinary(selectedFile);

    if (result?.secure_url) {
      setIsImageLoading(true);
      setImagePreview({
        preview: result.secure_url,
        data: result.secure_url,
      });

      setformDataAddEmployee((prev: any) => ({
        ...prev,
        profileUrl: result.secure_url,
      }));
    }

    if (fileInputRef.current) {
      fileInputRef.current.value = "";
    }

    // Reset uploading state
    setIsUploadingImage(false);
  };

  const uploadFileToCloudinary = async (file: File) => {
    const UPLOAD_PRESET: any = process.env.REACT_APP_UPLOAD_PRESET;
    const CLOUDINARY_URL = `${process.env.REACT_APP_API_CLOUDNIRY_URL}/${process.env.REACT_APP_CLOUD_NAME}/upload`;
    const FOLDER_PATH = "cms/profile_pic/" + user?.userDetails.id;

    const formData = new FormData();
    formData.append("file", file);
    formData.append("upload_preset", UPLOAD_PRESET);
    formData.append("folder", FOLDER_PATH);

    try {
      const response = await axios.post(CLOUDINARY_URL, formData);
      return response.data;
    } catch (error) {
      console.error("Error uploading file:", error);
      showBasicAlert("Failed to upload file. Please try again.");
      return null;
    }
  };

  const handleImageLoad = () => {
    setIsImageLoading(false);
  };

  const handleImageError = () => {
    setIsImageLoading(false);
    showBasicAlert("Failed to load image. Please try again.");
  };

  const handleJoiningDateChange = (date: any) => {
    date = date.$D + "-" + (parseInt(date.$M) + 1) + "-" + date.$y;
    setformDataAddEmployee((prev) => ({ ...prev, joiningDate: date }));
  };

  const handleDOBChange = (date: any) => {
    date = date.$D + "-" + (parseInt(date.$M) + 1) + "-" + date.$y;
    setformDataAddEmployee((prev) => ({ ...prev, dob: date }));
  };

  // Responsibilities handlers
  const handleResponsibilityInputChange = (e: any) => {
    setResponsibilityInput(e.target.value);
  };

  const handleResponsibilitySubmit = (e: any) => {
    e.preventDefault();
    if (responsibilityInput.trim() === "") {
      showBasicAlert("Please enter a responsibility.");
      return;
    }
    setformDataAddEmployee((prev: any) => ({
      ...prev,
      responsibilities: [...prev.responsibilities, responsibilityInput.trim()],
    }));
    setResponsibilityInput("");
  };

  const handleResponsibilityRemove = (responsibilityToRemove: string) => {
    setformDataAddEmployee((prev: any) => ({
      ...prev,
      responsibilities: prev.responsibilities.filter(
        (responsibility: string) => responsibility !== responsibilityToRemove
      ),
    }));
  };

  const departmentChoose = [
    ...getDepartmanet.map((department) => ({
      value: department.key,
      label: department.Department,
    })),
  ];

  const getFilteredDesignations = () => {
    if (!selectedDepartmentKey) {
      return getDesignation.map((designation) => ({
        value: designation.key,
        label: designation.Designation,
      }));
    }

    return getDesignation
      .filter((designation) => designation.Department_id == selectedDepartmentKey)
      .map((designation) => ({
        value: designation.key,
        label: designation.Designation,
      }));
  };

  const filteredDesignationChoose = getFilteredDesignations();

  const reportingOfficerChoose = [
    ...getReportingOfficer.map((officer) => ({
      value: officer.key,
      label:
        officer.name + " - " + officer.Designation + " - " + officer.Department,
    })),
  ];

  const companyChoose = [
    ...getAllCompanyList.map((company) => ({
      value: company.id,
      label: company.name + " - " + company.type,
    })),
  ];

  const companyChooseFilter = getAllCompanyList.map((company) => ({
    value: `${company.id}-${company.type}`,
    label: `${company.name}-${company.type}`,
  }));

  const handleInputChange = (e: any) => {
    const { name, value } = e.target;
    setformDataAddEmployee((prev) => ({ ...prev, [name]: value }));
  };

  const handleCountryCodeChange = (e: any) => {
    const country_code = e.target.value;
    setformDataAddEmployee((prevData) => ({
      ...prevData,
      countryCode: country_code,
    }));
  };

  const handleCountryCodeOfficialChange = (e: any) => {
    const country_code = e.target.value;
    setformDataAddEmployee((prevData) => ({
      ...prevData,
      official_phone_code: country_code,
    }));
  };

  const handleSubmit = async (e: any) => {
    try {
      setIsLoading(true);
      formDataAddEmployee.signature = signature;

      const response = await api.post(
        "userService/addEmployee",
        formDataAddEmployee
      );
      setIsLoading(false);
      showBasicAlert(response.data.message[0].msg);
      setformDataAddEmployee(initialAddEmployyeFormData);
      setImagePreview({
        preview: "",
        data: "",
      });
      document.getElementById("modal_closed")?.click();

      await fetchUpdatedRecords();
    } catch (error: any) {
      setIsLoading(false);
      showBasicAlert(error.data.message[0].msg);
    }
  };

  const [deleteRecord, setDeleteRecord] = useState<{
    key: number;
    name: string;
  } | null>(null);

  const handleDelete = async () => {
    if (deleteRecord) {
      try {
        var id = deleteRecord.key;

        // Find the employee in the existing data
        const employee = data.find(item => item.key === id);

        if (!employee.dol || employee.dol === "" || employee.dol === null) {
          showBasicAlert("Cannot delete employee. Date of Leaving is not set. Please set the Date of Leaving before deleting.");
          setDeleteRecord(null);
          return;
        }
        // if (employee.Status === "Active") {
        //   showBasicAlert("Cannot delete active employee. Please set status to Inactive and set Date of Leaving before deleting.");
        //   setDeleteRecord(null);
        //   return;
        // }
        try {
          var id = deleteRecord.key;
          try {
            setIsLoading(true);
            const response = await api.post("userService/deleteEmployee", {
              signature,
              id,
            });
            await updateUI();
            setIsLoading(false);
            showBasicAlert(response.data.message[0].msg);
          } catch (error: any) {
            setIsLoading(false);
            showBasicAlert(error.data.message[0].msg);
            console.error("Error submitting data", error);
          }
        } catch (error) {
          console.error("Error deleting item:", error);
          alert("Failed to delete item.");
        }
      } catch (error) {
        console.error("Error deleting item:", error);
        showBasicAlert("Failed to delete item.");
      }
      setDeleteRecord(null);
    }
  };

  const handleExportPDF = () => {
    const doc = new jsPDF();
    const columns = [
      "Emp Id",
      "Name",
      "Email",
      "Company",
      "Phone",
      "Department",
      "Joining Date",
      "Status",
    ];
    const tableData: (string | number)[][] = filteredData.map((item) => [
      item.UID,
      item.Name,
      item.Email,
      item.CompanyName,
      item.Phone,
      item.Department,
      item.JoiningDate,
      item.Status,
    ]);
    doc.autoTable({
      head: [columns],
      body: tableData,
    });
    doc.save("employee_list.pdf");
  };

  const handleExportExcel = () => {
    const ws = XLSX.utils.json_to_sheet(filteredData);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Sheet1");
    XLSX.writeFile(wb, "employee_list.xlsx");
  };

  const [selectedStartDate, setSelectedStartDate] =
    useState<moment.Moment | null>(null);
  const [selectedEndDate, setSelectedEndDate] = useState<moment.Moment | null>(
    null
  );

  const handleDateChange = (start: moment.Moment, end: moment.Moment) => {
    setSelectedStartDate(start);
    setSelectedEndDate(end);
  };

  const handleEditCredentialsModal = (record: any) => {
    const matchedCredential = providerEmailCredentials.find(
      (cred: any) => cred.user_id === record.key
    );
    setSelectedCredentialsUser(record);
    setEditCredentialsForm({
      provider: matchedCredential?.provider || "",
      email: matchedCredential?.email || "",
      password: "",
      id: matchedCredential?.id || "",
      company_type: matchedCredential?.company_type || "",
      company_id: matchedCredential?.company_id || "",
      user_id: matchedCredential?.user_id || "",
    });
  };

  const handleToggleLoginModal = (record: any) => {
    setSelectedCredentialsUser({
      LoginEnabled: record?.status, // Keep it as 0 or 1 (number)
      id: record?.id,
      user_id: record?.user_id,
      company_type: record?.company_type,
      company_id: record?.company_id,
    });
  };

  const handleEditCredentialsInputChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>
  ) => {
    const { name, value } = e.target;
    setEditCredentialsForm((prev) => ({ ...prev, [name]: value }));
  };
  const handleEditCredentials = async () => {
    try {
      setIsLoading(true);
      const payload: {
        signature: string | null;
        email: string;
        provider: string;
        password?: string;
        id?: number;
        company_type: string;
        company_id: number | string;
        user_id: number | string;
      } = {
        signature,
        email: editCredentialsForm.email,
        provider: editCredentialsForm.provider,
        id: editCredentialsForm.id ? Number(editCredentialsForm.id) : undefined,
        company_type: editCredentialsForm.company_type,
        company_id: editCredentialsForm.company_id,
        user_id: editCredentialsForm.user_id,
      };

      if (editCredentialsForm.password) {
        payload.password = editCredentialsForm.password;
      }
      const response = await api.post(
        "mailService/editProviderEmailCredentials",
        payload
      );
      showBasicAlert(response.data.message[0].msg);
      await updateUI();
      setEditCredentialsForm({
        provider: "",
        email: "",
        password: "",
        company_type: "",
        company_id: "",
        user_id: "",
      });
      setSelectedCredentialsUser(null);
      document.getElementById("edit_credentials_modal_close")?.click();
    } catch (error: any) {
      showBasicAlert(
        error.data?.message?.[0]?.msg || "Failed to edit credentials."
      );
    } finally {
      setIsLoading(false);
    }
  };

  const handleToggleLogin = async () => {
    try {
      setIsLoading(true);
      const newStatus = selectedCredentialsUser.LoginEnabled === 1 ? 0 : 1;
      const response = await api.post(
        "mailService/toggleProviderEmailCredentialStatus",
        {
          signature,
          id: selectedCredentialsUser.id,
          user_id: selectedCredentialsUser.user_id,
          company_type: selectedCredentialsUser.company_type,
          company_id: selectedCredentialsUser.company_id,
          status: newStatus,
        }
      );
      showBasicAlert(response.data.message[0].msg);
      await updateUI();
      setSelectedCredentialsUser(null);
      document.getElementById("toggle_login_modal_close")?.click();
    } catch (error: any) {
      showBasicAlert(
        error.data?.message?.[0]?.msg || "Failed to toggle login."
      );
    } finally {
      setIsLoading(false);
    }
  };

  const columns = [
    {
      title: "Name",
      dataIndex: "Name",
      render: (text: string, record: any) => (
        <div className="d-flex align-items-center">
          <Link
            to={all_routes.employeedetails.replace(":id", record.key)}
            state={{
              type: "emp_list",
            }}
            className="avatar avatar-md"
          >
            <ImageWithBasePath
              src={record.Image || `assets/img/users/user.png`}
              className="img-fluid rounded-circle"
              alt="img"
            />
          </Link>
          <div className="ms-2">
            <p className="text-dark mb-0">
              <Link
                to={all_routes.employeedetails.replace(":id", record.key)}
                state={{
                  type: "emp_list",
                }}
              >
                {record.Name}
              </Link>
            </p>
            <span className="fs-12">{record.CurrentRole}</span>
          </div>
        </div>
      ),
      sorter: (a: any, b: any) => {
        const charA = a.Name.charAt(0).toLowerCase();
        const charB = b.Name.charAt(0).toLowerCase();
        return charA.localeCompare(charB);
      },
      sortDirections: ["ascend", "descend"],
    },
    {
      title: "Email",
      dataIndex: "Email",
      sorter: (a: any, b: any) => a.Email.length - b.Email.length,
    },

    {
      title: "Phone",
      dataIndex: "Phone",
      sorter: (a: any, b: any) => a.Phone.length - b.Phone.length,
    },
    {
      title: "Department",
      dataIndex: "Department",
      sorter: (a: any, b: any) => a.Department.length - b.Department.length,
    },
    {
      title: "Joining Date",
      dataIndex: "JoiningDate",
      sorter: (a: any, b: any) =>
        new Date(a.JoiningDate).getTime() - new Date(b.JoiningDate).getTime(),
    },
    {
      title: "Status",
      dataIndex: "Status",
      render: (text: string, record: any) => (
        <div>
          <span
            className={`badge ${text === "Active" ? "badge-success" : text === "Suspended" ? "badge-warning" : "badge-danger"
              } d-inline-flex align-items-center badge-xs mb-1`}
          >
            <i className="ti ti-point-filled me-1" />
            {text}
          </span>
          {(text === "Inactive" || text === "Suspended") && record.dol && record.dol.trim() !== "" && (
            <div className="fs-12 text-muted">
              Left: {record.dol}
            </div>
          )}
        </div>
      ),
      sorter: (a: any, b: any) => a.Status.length - b.Status.length,
    },
    {
      title: "Credentials",
      dataIndex: "credentials",
      render: (text: String, record: any) => {
        const userCredential = providerEmailCredentials?.find(
          (cred: any) => cred.user_id === record.key
        );

        return (
          <div className="action-icon d-inline-flex">
            {!userCredential ? (
              <span
                className="text-muted"
                title="No credentials found. Credentials are managed elsewhere."
              >
                <i className="ti ti-lock-off me-1" />
                No Credentials
              </span>
            ) : (
              <>
                {/* Toggle Login Access */}
                <div
                  className="form-check form-switch me-2"
                  data-bs-toggle="modal"
                  data-bs-target="#toggle_login_modal"
                  style={{ display: "inline-block" }}
                >
                  <input
                    className="form-check-input"
                    type="checkbox"
                    id={`loginToggle-${userCredential?.id}`}
                    checked={userCredential?.status === 1}
                    onChange={() => handleToggleLoginModal(userCredential)}
                    style={{
                      cursor: "pointer",
                      backgroundColor:
                        userCredential?.status === 1 ? "orange" : "",
                      borderColor: userCredential?.status === 1 ? "orange" : "",
                    }}
                  />
                  <label
                    className="form-check-label fw-bold ms-2"
                    htmlFor={`loginToggle-${userCredential?.id}`}
                    style={{
                      color: userCredential?.status === 1 ? "orange" : "gray",
                    }}
                  ></label>
                </div>

                {/* Edit Credentials */}
                <Link
                  to="#"
                  data-bs-toggle="modal"
                  data-bs-target="#edit_credentials_modal"
                  onClick={() => handleEditCredentialsModal(record)}
                >
                  <i className="ti ti-edit" />
                </Link>
              </>
            )}
          </div>
        );
      },
    },

    {
      title: "Document",
      dataIndex: "actions",
      render: (text: String, record: any) => (
        <div className="action-icon d-inline-flex">
          <Link
            to="#"
            data-bs-toggle="modal"
            data-inert={true}
            data-bs-target="#upload_modal"
            onClick={() => handleUploadModal(record)}
            title="Upload"
          >
            <i className="ti ti-upload" />
          </Link>
          <Link
            to="#"
            data-bs-toggle="modal"
            data-bs-target="#view_documents_modal"
            onClick={() => handleViewDocuments(record)}
            title="View Doc"
          >
            <i className="ti ti-eye" />
          </Link>
        </div>
      ),
    },
    {
      title: "",
      dataIndex: "actions",
      render: (text: String, record: any) => (
        <div className="action-icon d-inline-flex">
          <Link
            to="#"
            className="me-2"
            data-bs-toggle="modal"
            data-inert={true}
            data-bs-target="#edit_employee"
            onClick={(e: any) => handleEditOpenModal(record)}
            title="Edit"
          >
            <i className="ti ti-edit" />
          </Link>
          <Link
            to="#"
            data-bs-toggle="modal"
            data-inert={true}
            data-bs-target="#delete_modal"
            onClick={() => setDeleteRecord(record)}
            title="Delete"
          >
            <i className="ti ti-trash" />
          </Link>
        </div>
      ),
    },
  ];
  //================================================
  // bulk upload logic
  const [selectedEmployeeKeys, setSelectedEmployeeKeys] = useState<any[]>([]);
  const filterEmployeesByCompany = (
    companyId: number | null,
    companyType: string | null
  ) => {
    if (!companyId || !companyType) return data;

    return data.filter((employee: any) => {
      const matchesCompanyId = employee.CompanyId === companyId;
      const matchesCompanyType = employee.CompanyType === companyType;
      return matchesCompanyId && matchesCompanyType;
    });
  };

  const filterEmployeesByDepartment = (
    department: string | null,
    filteredByCompany: any[]
  ) => {
    if (!department || department === "All Departments")
      return filteredByCompany;

    return filteredByCompany.filter(
      (employee: any) => employee.Department === department
    );
  };

  const filterEmployeesByDesignation = (
    designation: string | null,
    filteredByDepartment: any[]
  ) => {
    if (!designation || designation === "All Designations")
      return filteredByDepartment;

    return filteredByDepartment.filter(
      (employee: any) => employee.Designation === designation
    );
  };

  // Function to apply filters and log results
  const applyUploadFilters = (
    filters: FilterState,
    filterType: "single" | "bulk"
  ) => {
    // Step 1: Filter by company type and company ID
    let filteredByCompany = filterEmployeesByCompany(
      filters.companyId,
      filters.companyType
    );

    // Step 2: Filter by department
    let filteredByDepartment = filterEmployeesByDepartment(
      filters.department,
      filteredByCompany
    );

    // Step 3: Filter by designation
    let finalFiltered = filterEmployeesByDesignation(
      filters.designation,
      filteredByDepartment
    );

    return finalFiltered;
  };

  const handleBulkUploadFilterChange = (
    filterType: keyof FilterState,
    value: any
  ) => {
    setBulkUploadFilters((prev) => {
      const newFilters = { ...prev, [filterType]: value };

      if (filterType === "companyId" || filterType === "companyType") {
        newFilters.department = null;
        newFilters.designation = null;
      } else if (filterType === "department") {
        newFilters.designation = null;
      }

      const filteredEmployees = applyUploadFilters(newFilters, "bulk");

      // Update selected employees based on filters
      setSelectedEmployeeKeys(filteredEmployees.map((emp) => emp.key));

      return newFilters;
    });
  };


  const handleBulkShare = async () => {
    if (!selectedFile) return;

    // Get selected filters
    const { companyType, companyId, department, designation } = bulkUploadFilters;

    if (!companyId || !companyType) {
      showBasicAlert("Please select a company first");
      return;
    }

    if (!documentType.trim()) {
      showBasicAlert("Document Type is required.");
      return;
    }

    setUploading(true);

    try {
      let rule_type = '';
      let target_value = null;

      if (designation && designation !== "All Designations") {
        const desig = getDesignation.find(d => d.Designation === designation);
        if (desig) {
          rule_type = 'by_designation';
          target_value = { designation_ids: [desig.key] };
        }
      }
      else if (department && department !== "All Departments") {
        const dept = getDepartmanet.find(d => d.Department === department);
        if (dept) {
          rule_type = 'by_department';
          target_value = { department_ids: [dept.key] };
        }
      } else {
        // Default to all company users
        rule_type = 'all_company_users';
      }

      // Prepare form data for bulk upload with rule
      const formData = new FormData();
      formData.append("file", selectedFile);
      formData.append("name", selectedFile.name);
      formData.append("document_type", documentType);
      formData.append("rule_type", rule_type);
      if (target_value) {
        formData.append("target_value", JSON.stringify(target_value));
      }

      formData.append("access_type", "view");
      formData.append("signature", signature || "");

      // Call new API endpoint for bulk upload with rule
      const response = await api.post("driveService/uploadBulkDocumentWithRule", formData);
      const result = response.data?.message?.[0];

      if (result?.status) {
        showBasicAlert(
          `Bulk document uploaded successfully! Access rule: ${rule_type.replace('_', ' ')}`
        );

        // Reset form
        setSelectedFile(null);
        setDocumentType("");
        setSelectedEmployeeKeys([]);

        // Close modal
        document.getElementById("emp_bulk_share_doc_upload_modal_close")?.click();
      } else {
        showBasicAlert(result?.msg || "Upload failed.");
      }
    } catch (error: any) {
      console.error("Bulk upload error:", error);
      showBasicAlert(
        error?.response?.data?.message?.[0]?.msg || "Upload failed."
      );
    } finally {
      setUploading(false);
    }
  };

  const handleBulkShareHelper = async (fileId: any, userIds: any[]) => {
    const data = {
      signature,
      file_id: fileId,
      users: userIds.map((userId) => ({
        user_id: userId,
        access_type: "view", // or make this dynamic
      })),
    };

    const response = await api.post(
      "driveService/shareFileWithPermissions",
      data
    );

    if (!response?.data?.message?.[0]?.status) {
      throw new Error("Failed to share the file with selected employees.");
    }

    return response;
  };

  //==============================================

  const getModalContainer = () => {
    const modalElement = document.getElementById("add_employee");
    return modalElement ? modalElement : document.body;
  };

  const [passwordVisibility, setPasswordVisibility] = useState({
    password: false,
    confirmPassword: false,
  });

  const togglePasswordVisibility = (field: PasswordField) => {
    setPasswordVisibility((prevState) => ({
      ...prevState,
      [field]: !prevState[field],
    }));
  };

  const [statusFilter, setStatusFilter] = useState<string | null>(null);
  const [sortBy, setSortBy] = useState<string>("Last 7 Days");

  const handleFilterApply = (newFilters: EmployeeFilters) => {

    setFilters(prev => ({
      ...prev,
      status: newFilters.status,
      department: newFilters.department,
      designation: newFilters.designation,
      sortBy: newFilters.sortBy,
      joiningDate: newFilters.joiningDate,
      createdDate: newFilters.createdDate,
      gender: newFilters.gender
      // company is not updated here
    }));

    // Update other states
    if (newFilters.status !== "All") {
      setStatusFilter(newFilters.status);
    } else {
      setStatusFilter("Active");
    }

    if (newFilters.department !== "All Departments") {
      setDepartmentFilter(newFilters.department);
    } else {
      setDepartmentFilter(null);
    }

    if (newFilters.sortBy) {
      setSortBy(newFilters.sortBy);
    }
  };

  const handleFilterReset = () => {
    // Keep the current company selection
    const currentCompany = companyName;

    const defaultFilters = {
      status: "Active",
      department: "All Departments",
      designation: "All Designations",
      sortBy: "Last 7 Days",
      joiningDate: null,
      createdDate: null,
      company: currentCompany, // Keep current company
      gender: "All Genders"
    };

    setFilters(defaultFilters);
    setStatusFilter("Active");
    setDepartmentFilter(null);
    setSortBy("Last 7 Days");
    setSelectedStartDate(null);
    setSelectedEndDate(null);
  };
  const activeFilterCount = () => {
    let count = 0;

    if (filters.status !== "Active") count++;
    if (filters.department !== "All Departments") count++;
    if (filters.designation !== "All Designations") count++;
    if (filters.sortBy !== "Last 7 Days") count++;
    if (filters.joiningDate) count++;
    if (filters.createdDate) count++;
    // if (filters.company) count++;

    return count;
  };

  useEffect(() => {
    if (filters.company) {
      setCompanyName(filters.company);
    }
  }, [filters.company]);

  const getFilterPanelData = () => {
    const uniqueDepartments = Array.from(
      new Set(
        data
          .filter(item => companyName && item.CompanyName === companyName.name)
          .map(item => item.Department)
          .filter(dept => dept)
      )
    ).sort();

    return {
      allCompanies: getAllCompanyList,
      allDepartments: uniqueDepartments,
      allDesignations: getDesignation
    };
  };
  const handleReset = () => {
    setData(data);
    setFilteredData(data);
    setSelectedEndDate(null);
    setSelectedStartDate(null);
    setStatusFilter("Active");
    setDepartmentFilter(null);
    if (getAllCompanyList.length > 0) {
      setCompanyName({
        id: getAllCompanyList[0].id,
        name: getAllCompanyList[0].name,
        type: getAllCompanyList[0].type,
      });
    }
    setSortBy("Last 7 Days");
  };

  useEffect(() => {
    if (data.length > 0) {
      applyFilters(data);
    } else {
      setFilteredData([]);
    }
  }, [filters, data]);
  const [modalData, setModalData] = useState(null);

  useEffect(() => {
    if (data.length > 0) {
      applyFilters(data);
    }
  }, [
    statusFilter,
    departmentFilter,
    sortBy,
    selectedStartDate,
    selectedEndDate,
    companyName,
    data,
  ]);

  const handleEditOpenModal = (record: any) => {
    const departmentKey = getDepartmanet.find(
      (dept) => dept.Department === record.Department
    )?.key || "";
    const processedRecord = {
      ...record,
      CountryCode: CountryCode,
      signature: signature,
      getAllCompanyList: getAllCompanyList,
      getDesignation: getDesignation,
      getReportingOfficer: getReportingOfficer,
      DepartmentId: departmentKey,
    };

    setModalData(processedRecord);
  };

  const emojiFromUPlus = (val?: string) => {
    if (!val) return "";
    const tokens =
      val.match(/U\+[0-9A-F]{4,6}/gi)?.map((t) => t.slice(2)) ||
      val
        .replace(/U\+/gi, "")
        .split(/[^0-9A-F]+/i)
        .filter(Boolean);

    return String.fromCodePoint(...tokens.map((h) => parseInt(h, 16)));
  };
  return (
    <>
      {isLoading && <Loader />}

      <div className="page-wrapper">
        <div className="content">
          <div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
            <div className="my-auto mb-2">
              <h2 className="mb-1">Employee</h2>
              <nav>
                <ol className="breadcrumb mb-0">
                  <li className="breadcrumb-item">
                    <Link to={all_routes.adminDashboard}>
                      <i className="ti ti-smart-home" />
                    </Link>
                  </li>
                  <li className="breadcrumb-item">Employee</li>
                  <li className="breadcrumb-item active" aria-current="page">
                    Employee List
                  </li>
                </ol>
              </nav>
            </div>
            <div className="d-flex my-xl-auto right-content align-items-center flex-wrap ">
              <div className="me-2 mb-2">
                <div className="d-flex align-items-center border bg-white rounded p-1 me-2 icon-list">
                  <Link
                    to={all_routes.employeeList}
                    className="btn btn-icon btn-sm active bg-primary text-white me-1"
                    title="List"
                  >
                    <i className="ti ti-list-tree" />
                  </Link>
                  <Link
                    to={all_routes.employeeGrid}
                    className="btn btn-icon btn-sm"
                    title="Grid"
                  >
                    <i className="ti ti-layout-grid" />
                  </Link>
                </div>
              </div>
              <div className="me-2 mb-2">
                <div
                  className="d-flex align-items-center"
                  style={{ minWidth: "250px" }}
                >
                  <CommonSelect
                    key={companyKey}
                    className="select"
                    options={companyChooseFilter}
                    defaultValue={
                      companyName
                        ? {
                          value: `${companyName.id}-${companyName.type}`,
                          label: `${companyName.name} - ${companyName.type}`,
                        }
                        : companyChooseFilter.length > 0
                          ? companyChooseFilter[0]
                          : undefined
                    }
                    onChange={handleCompanySelect}
                  />
                </div>
              </div>
              <div className="me-2 mb-2">
                <div className="dropdown">
                  <Link
                    to="#"
                    className="dropdown-toggle btn btn-white d-inline-flex align-items-center"
                    data-bs-toggle="dropdown"
                  >
                    <i className="ti ti-file-export me-1" />
                    Export
                  </Link>
                  <ul className="dropdown-menu  dropdown-menu-end p-3">
                    <li>
                      <Link
                        to="#"
                        className="dropdown-item rounded-1"
                        onClick={handleExportPDF}
                      >
                        <i className="ti ti-file-type-pdf me-1" />
                        Export as PDF
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="#"
                        className="dropdown-item rounded-1"
                        onClick={handleExportExcel}
                      >
                        <i className="ti ti-file-type-xls me-1" />
                        Export as Excel{" "}
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="mb-2">
                <Link
                  to="#"
                  data-bs-toggle="modal"
                  data-inert={true}
                  data-bs-target="#add_employee"
                  className="btn btn-primary d-flex align-items-center"
                  onClick={() => {
                    setformDataAddEmployee((prev: any) => ({
                      ...prev,
                      companyId: "",
                      company: "Select Company",
                    }));
                  }}
                >
                  <i className="ti ti-circle-plus me-2" />
                  Add Employee
                </Link>
              </div>
              <div className="head-icons ms-2">
                <CollapseHeader />
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-xl col-lg-4 col-md-6 d-flex">
              <div className="card flex-fill">
                <div className="card-body d-flex align-items-center justify-content-between">
                  <div className="d-flex align-items-center overflow-hidden">
                    <div>
                      <span className="avatar avatar-lg bg-dark rounded-circle">
                        <i className="ti ti-users" />
                      </span>
                    </div>
                    <div className="ms-2 overflow-hidden">
                      <p className="fs-12 fw-medium mb-1 text-truncate">
                        Total Employee
                      </p>
                      <h4>
                        {data?.filter(
                          (item) =>
                            companyName &&
                            item.CompanyName === companyName.name
                        ).length || 0}
                      </h4>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-xl col-lg-4 col-md-6 d-flex">
              <div className="card flex-fill">
                <div className="card-body d-flex align-items-center justify-content-between">
                  <div className="d-flex align-items-center overflow-hidden">
                    <div>
                      <span className="avatar avatar-lg bg-success rounded-circle">
                        <i className="ti ti-user-share" />
                      </span>
                    </div>
                    <div className="ms-2 overflow-hidden">
                      <p className="fs-12 fw-medium mb-1 text-truncate">
                        Active
                      </p>
                      <h4>
                        {data?.filter(
                          (item) =>
                            item.Status === "Active" &&
                            companyName &&
                            item.CompanyName === companyName.name
                        ).length || 0}
                      </h4>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-xl col-lg-4 col-md-6 d-flex">
              <div className="card flex-fill">
                <div className="card-body d-flex align-items-center justify-content-between">
                  <div className="d-flex align-items-center overflow-hidden">
                    <div>
                      <span className="avatar avatar-lg bg-danger rounded-circle">
                        <i className="ti ti-user-pause" />
                      </span>
                    </div>
                    <div className="ms-2 overflow-hidden">
                      <p className="fs-12 fw-medium mb-1 text-truncate">
                        InActive
                      </p>
                      <h4>
                        {data?.filter(
                          (item) =>
                            item.Status === "Inactive" &&
                            companyName &&
                            item.CompanyName === companyName.name
                        ).length || 0}
                      </h4>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-xl col-lg-4 col-md-6 d-flex">
              <div className="card flex-fill">
                <div className="card-body d-flex align-items-center justify-content-between">
                  <div className="d-flex align-items-center overflow-hidden">
                    <div>
                      <span className="avatar avatar-lg bg-warning rounded-circle">
                        <i className="ti ti-user-exclamation" />
                      </span>
                    </div>
                    <div className="ms-2 overflow-hidden">
                      <p className="fs-12 fw-medium mb-1 text-truncate">
                        Suspended
                      </p>
                      <h4>
                        {data?.filter(
                          (item) =>
                            item.Status === "Suspended" &&
                            companyName &&
                            item.CompanyName === companyName.name
                        ).length || 0}
                      </h4>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-xl col-lg-4 col-md-6 d-flex">
              <div className="card flex-fill">
                <div className="card-body d-flex align-items-center justify-content-between">
                  <div className="d-flex align-items-center overflow-hidden">
                    <div>
                      <span className="avatar avatar-lg bg-info rounded-circle">
                        <i className="ti ti-user-plus" />
                      </span>
                    </div>
                    <div className="ms-2 overflow-hidden">
                      <p className="fs-12 fw-medium mb-1 text-truncate">
                        New Joiners
                      </p>
                      <h4>
                        {data?.filter((item) => {
                          const today = moment();
                          const joiningDate = moment(item.JoiningDate, "DD-MM-YYYY");

                          const isCurrentMonth =
                            joiningDate.month() === today.month() &&
                            joiningDate.year() === today.year();

                          return (
                            companyName &&
                            item.CompanyName === companyName.name &&
                            isCurrentMonth
                          );
                        }).length || 0}
                      </h4>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="card">
            <div className="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3">
              <h5>Employee List</h5>

              {/* Right Actions */}
              <div className="d-flex my-xl-auto right-content align-items-center flex-wrap row-gap-3">

                {/* Bulk Documents */}
                <div className="dropdown d-inline-block me-2">
                  <button
                    className="btn btn-md btn-info dropdown-toggle d-flex align-items-center"
                    type="button"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    <i className="ti ti-upload me-2"></i>
                    Bulk Documents
                  </button>
                  <ul className="dropdown-menu dropdown-menu-end">
                    <li>
                      <Link
                        to="#"
                        className="dropdown-item"
                        data-bs-toggle="modal"
                        data-bs-target="#emp_bulk_share_doc_upload_modal"
                      >
                        <i className="ti ti-upload me-2"></i>
                        Upload New Bulk Document
                      </Link>
                    </li>
                    <li>
                      <hr className="dropdown-divider" />
                    </li>
                    <li>
                      <Link
                        to="#"
                        className="dropdown-item"
                        data-bs-toggle="modal"
                        data-bs-target="#bulk_documents_view_modal"
                        onClick={() => setShowBulkViewModal(true)}
                      >
                        <i className="ti ti-files me-2"></i>
                        View Bulk Documents
                      </Link>
                    </li>
                  </ul>
                </div>

                {/* Filter Button */}
                <div className="me-2">
                  <button
                    className="btn btn-outline-primary d-flex align-items-center position-relative"
                    onClick={() => setIsFilterPanelOpen(true)}
                  >
                    <i className="ti ti-filter me-2" />
                    Filters
                    {activeFilterCount() > 0 && (
                      <span className="badge bg-primary rounded-pill ms-2">
                        {activeFilterCount()}
                      </span>
                    )}
                  </button>
                </div>

                {/* Quick Status Filter */}
                <div className="dropdown me-2">
                  <Link
                    to="#"
                    className="dropdown-toggle btn btn-white d-inline-flex align-items-center"
                    data-bs-toggle="dropdown"
                  >
                    Status: {filters.status}
                  </Link>
                  <ul className="dropdown-menu dropdown-menu-end p-2">
                    <li>
                      <Link
                        to="#"
                        className="dropdown-item rounded-1"
                        onClick={() => handleFilterApply({ ...filters, status: "Active" })}
                      >
                        Active
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="#"
                        className="dropdown-item rounded-1"
                        onClick={() => handleFilterApply({ ...filters, status: "Inactive" })}
                      >
                        Inactive
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="#"
                        className="dropdown-item rounded-1"
                        onClick={() => handleFilterApply({ ...filters, status: "Suspended" })}
                      >
                        Suspended
                      </Link>
                    </li>
                    <li>
                      <hr className="dropdown-divider" />
                    </li>
                    <li>
                      <Link
                        to="#"
                        className="dropdown-item rounded-1"
                        onClick={() => handleFilterApply({ ...filters, status: "All" })}
                      >
                        All Status
                      </Link>
                    </li>
                  </ul>
                </div>

                {/* Reset Button */}
                <div>
                  <button
                    type="button"
                    className="btn btn-success"
                    onClick={handleFilterReset}
                  >
                    Reset
                  </button>
                </div>

              </div>
            </div>

            <div className="card-body p-0">
              <Table
                key={JSON.stringify(filteredData)}
                dataSource={filteredData}
                columns={columns}
                Selection={false}
              />
            </div>
          </div>
        </div>
        <div className="footer d-sm-flex align-items-center justify-content-between border-top bg-white p-3">
          <p className="mb-0">2025 © CMS.</p>
          <p>
            Designed & Developed By{" "}
            <Link to="#" className="text-primary">
              ZYVO
            </Link>
          </p>
        </div>
      </div>
      <div className="modal fade" id="add_employee">
        <div className="modal-dialog modal-dialog-centered modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <div className="d-flex align-items-center">
                <h4 className="modal-title me-2">Add New Employee</h4>
              </div>
              <button
                type="button"
                className="btn-close custom-btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <i className="ti ti-x" />
              </button>
            </div>
            <form onSubmit={handleResponsibilitySubmit}>
              <div className="contact-grids-tab">
                <ul className="nav nav-underline" id="myTab" role="tablist">
                  <li className="nav-item" role="presentation">
                    <button
                      className="nav-link active"
                      id="info-tab"
                      data-bs-toggle="tab"
                      data-bs-target="#basic-info"
                      type="button"
                      role="tab"
                      aria-selected="true"
                    >
                      Basic Information
                    </button>
                  </li>
                </ul>
              </div>
              <div className="tab-content" id="myTabContent">
                <div
                  className="tab-pane fade show active"
                  id="basic-info"
                  role="tabpanel"
                  aria-labelledby="info-tab"
                  tabIndex={0}
                >
                  <div className="modal-body pb-0 ">
                    <div className="row">
                      <div className="col-md-12">
                        <div className="d-flex align-items-center flex-wrap row-gap-3 bg-light w-100 rounded p-3 mb-4">
                          <div className="d-flex align-items-center justify-content-center avatar avatar-xxl rounded-circle border border-dashed me-2 flex-shrink-0 text-dark frames position-relative">
                            {isImageLoading && (
                              <div className="position-absolute top-50 start-50 translate-middle">
                                <div
                                  className="spinner-border spinner-border-sm text-primary"
                                  role="status"
                                >
                                  <span className="visually-hidden">
                                    Loading image...
                                  </span>
                                </div>
                              </div>
                            )}
                            <img
                              src={
                                imagePreview?.preview ||
                                "assets/img/users/user.png"
                              }
                              alt="Profile preview"
                              className="rounded-circle"
                              style={{
                                width: "100%",
                                height: "100%",
                                objectFit: "cover",
                                opacity: isImageLoading ? 0.5 : 1,
                              }}
                              onLoad={handleImageLoad}
                              onError={handleImageError}
                            />
                          </div>
                          <div className="profile-upload">
                            <div className="mb-2">
                              <h6 className="mb-1">Upload Profile Image</h6>
                              <p className="fs-12">
                                Image should be below 4 mb
                              </p>
                            </div>
                            <div className="profile-uploader d-flex align-items-center">
                              <div
                                className={`drag-upload-btn btn btn-sm btn-primary me-2 ${isUploadingImage ? "uploading" : ""
                                  }`}
                              >
                                {isUploadingImage ? (
                                  <>
                                    <div
                                      className="spinner-border spinner-border-sm text-white me-1"
                                      role="status"
                                    >
                                      <span className="visually-hidden">
                                        Loading...
                                      </span>
                                    </div>
                                    Uploading...
                                  </>
                                ) : (
                                  "Upload"
                                )}
                                <input
                                  name="file"
                                  type="file"
                                  accept="image/*"
                                  className="form-control image-sign"
                                  onChange={handleFileChange}
                                  disabled={isUploadingImage}
                                  style={{
                                    position: "absolute",
                                    top: 0,
                                    left: 0,
                                    width: "100%",
                                    height: "100%",
                                    opacity: 0,
                                    cursor: isUploadingImage
                                      ? "not-allowed"
                                      : "pointer",
                                  }}
                                />
                              </div>
                              {imagePreview && !isUploadingImage && (
                                <Link
                                  to="#"
                                  className="btn btn-light btn-sm"
                                  onClick={() => {
                                    setImagePreview({
                                      preview: "",
                                      data: "",
                                    });
                                    if (fileInputRef.current) {
                                      fileInputRef.current.value = "";
                                    }
                                  }}
                                >
                                  Cancel
                                </Link>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="col-md-12">
                        <div className="mb-3">
                          <label className="form-label">
                            Company <span className="text-danger"> *</span>
                          </label>
                          <CommonSelect
                            className="select"
                            options={companyChoose}
                            defaultValue={{
                              value: formDataAddEmployee.companyId,
                              label: formDataAddEmployee.company,
                            }}
                            onChange={async (selectedOption: any) => {
                              setformDataAddEmployee((prev: any) => ({
                                ...prev,
                                companyId: selectedOption.value,
                                company: selectedOption.label,
                              }));
                              await fetchReportingOfficer(
                                selectedOption.value,
                                selectedOption.label
                              );
                            }}
                          />
                        </div>
                      </div>
                      <div className="col-md-2">
                        <div className="mb-3">
                          <label className="form-label">
                            Salutation <span className="text-danger"> *</span>
                          </label>
                          <select
                            className="form-control"
                            name="salutation"
                            value={formDataAddEmployee.salutation}
                            onChange={handleInputChange}
                          >
                            <option value="">Select</option>
                            {salutation.map((data) => (
                              <option key={data.value} value={data.value}>
                                {data.label}
                              </option>
                            ))}
                          </select>
                        </div>
                      </div>
                      <div className="col-md-4">
                        <div className="mb-3">
                          <label className="form-label">
                            First Name <span className="text-danger"> *</span>
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            name="firstName"
                            value={formDataAddEmployee.firstName}
                            onChange={handleInputChange}
                          />
                        </div>
                      </div>
                      <div className="col-md-4">
                        <div className="mb-3">
                          <label className="form-label">
                            Last Name
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            name="lastName"
                            value={formDataAddEmployee.lastName}
                            onChange={handleInputChange}
                          />
                        </div>
                      </div>

                      <div className="col-md-2">
                        <div className="mb-3">
                          <label className="form-label">
                            Gender <span className="text-danger"> *</span>
                          </label>
                          <select
                            className="form-control"
                            name="gender"
                            value={formDataAddEmployee.gender}
                            onChange={handleInputChange}
                          >
                            <option value="">Select</option>
                            {gender.map((data) => (
                              <option key={data.value} value={data.value}>
                                {data.label}
                              </option>
                            ))}
                          </select>
                        </div>
                      </div>

                      <div className="col-md-2">
                        <div className="mb-3">
                          <label className="form-label">
                            Code <span className="text-danger"> *</span>
                          </label>
                          <select
                            className="form-control"
                            name="countryCode"
                            value={formDataAddEmployee.countryCode}
                            onChange={handleCountryCodeChange}
                          >
                            <option value="">Select</option>
                            {CountryCode.map((country, index) => (
                              <option key={index} value={country.phonecode}>
                                {country.ios2} {emojiFromUPlus(country.emojiU)}
                                {" +"}
                                {country.phonecode}
                              </option>
                            ))}
                          </select>
                        </div>
                      </div>
                      <div className="col-md-4">
                        <div className="mb-3">
                          <label className="form-label">
                            Phone Number <span className="text-danger"> *</span>
                          </label>
                          <input
                            type="tel"
                            className="form-control"
                            name="phoneNumber"
                            value={formDataAddEmployee.phoneNumber}
                            onChange={handleInputChange}
                            onInput={(e) => {
                              const target = e.target as HTMLInputElement;
                              target.value = target.value
                                .replace(/\D/g, "")
                                .slice(0, 12);
                            }}
                          />
                        </div>
                      </div>

                      <div className="col-md-2">
                        <div className="mb-3">
                          <label className="form-label">
                            Code <span className="text-danger"> *</span>
                          </label>
                          <select
                            className="form-control"
                            name="official_phone_code"
                            value={formDataAddEmployee.official_phone_code}
                            onChange={handleCountryCodeOfficialChange}
                          >
                            <option value="">Select</option>
                            {CountryCode.map((country, index) => (
                              <option key={index} value={country.phonecode}>
                                {country.ios2} {emojiFromUPlus(country.emojiU)}
                                {" +"}
                                {country.phonecode}
                              </option>
                            ))}
                          </select>
                        </div>
                      </div>
                      <div className="col-md-4">
                        <div className="mb-3">
                          <label className="form-label">
                            Official Phone Number{" "}
                            <span className="text-danger"> *</span>
                          </label>
                          <input
                            type="tel"
                            className="form-control"
                            name="official_mobile_no"
                            value={formDataAddEmployee.official_mobile_no}
                            onChange={handleInputChange}
                            onInput={(e) => {
                              const target = e.target as HTMLInputElement;
                              target.value = target.value
                                .replace(/\D/g, "")
                                .slice(0, 12);
                            }}
                          />
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="mb-3">
                          <label className="form-label">
                            D.O.B ({formDataAddEmployee.dob})
                            <span className="text-danger"> *</span>
                          </label>
                          <div className="input-icon-end position-relative">
                            <DatePicker
                              className="form-control datetimepicker"
                              format={{
                                format: "DD-MM-YYYY",
                                type: "mask",
                              }}
                              getPopupContainer={getModalContainer}
                              placeholder="DD-MM-YYYY"
                              onChange={handleDOBChange}
                              maxDate={today}
                            />
                            <span className="input-icon-addon">
                              <i className="ti ti-calendar text-gray-7" />
                            </span>
                          </div>
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="mb-3">
                          <label className="form-label">
                            Joining Date ({formDataAddEmployee.joiningDate})
                            <span className="text-danger"> *</span>
                          </label>
                          <div className="input-icon-end position-relative">
                            <DatePicker
                              className="form-control datetimepicker"
                              format={{
                                format: "DD-MM-YYYY",
                                type: "mask",
                              }}
                              getPopupContainer={getModalContainer}
                              placeholder="DD-MM-YYYY"
                              onChange={handleJoiningDateChange}
                              maxDate={today}
                            />
                            <span className="input-icon-addon">
                              <i className="ti ti-calendar text-gray-7" />
                            </span>
                          </div>
                        </div>
                      </div>
                      <div className="col-md-4">
                        <div className="mb-3">
                          <label className="form-label">
                            Username <span className="text-danger"> *</span>
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            name="username"
                            value={formDataAddEmployee.username}
                            onChange={handleInputChange}
                          />
                        </div>
                      </div>
                      <div className="col-md-4">
                        <div className="mb-3">
                          <label className="form-label">
                            Email <span className="text-danger"> *</span>
                          </label>
                          <input
                            type="email"
                            className="form-control"
                            name="email"
                            value={formDataAddEmployee.email}
                            onChange={handleInputChange}
                          />
                        </div>
                      </div>
                      <div className="col-md-4">
                        <div className="mb-3 ">
                          <label className="form-label">
                            Password <span className="text-danger"> *</span>
                          </label>
                          <div className="pass-group">
                            <input
                              type={
                                passwordVisibility.password
                                  ? "text"
                                  : "password"
                              }
                              className="pass-input form-control"
                              name="password"
                              value={formDataAddEmployee.password}
                              onChange={handleInputChange}
                            />
                            <span
                              className={`ti toggle-passwords ${passwordVisibility.password
                                ? "ti-eye"
                                : "ti-eye-off"
                                }`}
                              onClick={() =>
                                togglePasswordVisibility("password")
                              }
                            ></span>
                          </div>
                        </div>
                      </div>
                      <div className="col-md-4">
                        <div className="mb-3">
                          <label className="form-label">
                            Department <span className="text-danger"> *</span>
                          </label>
                          <CommonSelect
                            className="select"
                            options={departmentChoose}
                            defaultValue={{
                              value: formDataAddEmployee.departmentKey,
                              label: formDataAddEmployee.department,
                            }}
                            onChange={(selectedOption: any) => {
                              setSelectedDepartmentKey(selectedOption.value); // Store the department key
                              setformDataAddEmployee((prev: any) => ({
                                ...prev,
                                department: selectedOption.label,
                                departmentKey: selectedOption.value,
                                designation: "", // Reset designation when department changes
                                designationKey: "", // Reset designation key
                              }));
                            }}
                          />
                        </div>
                      </div>
                      <div className="col-md-4">
                        <div className="mb-3">
                          <label className="form-label">
                            Designation <span className="text-danger"> *</span>
                          </label>
                          <CommonSelect
                            className="select"
                            options={filteredDesignationChoose}
                            defaultValue={{
                              value: formDataAddEmployee.designationKey,
                              label: formDataAddEmployee.designation,
                            }}
                            isDisabled={!selectedDepartmentKey}
                            onChange={(selectedOption: any) =>
                              setformDataAddEmployee((prev: any) => ({
                                ...prev,
                                designation: selectedOption.label,
                                designationKey: selectedOption.value,
                              }))
                            }
                          />
                        </div>
                      </div>
                      <div className="col-md-4">
                        <div className="mb-3">
                          <label className="form-label">
                            Reporting Officer{" "}
                            <span className="text-danger"> *</span>
                          </label>
                          <CommonSelect
                            className="select"
                            options={reportingOfficerChoose}
                            defaultValue={reportingOfficerChoose.find(
                              (opt) =>
                                opt.value ===
                                formDataAddEmployee.reportingOfficer
                            )}
                            onChange={(selectedOption: any) =>
                              setformDataAddEmployee((prev: any) => ({
                                ...prev,
                                reportingOfficer: selectedOption.value,
                              }))
                            }
                          />
                        </div>
                      </div>
                      <div className="col-md-3">
                        <div className="mb-3">
                          <label className="form-label">
                            User Type <span className="text-danger">*</span>
                          </label>
                          <select
                            className="form-control"
                            name="userType"
                            value={formDataAddEmployee.userType}
                            onChange={handleInputChange}
                          >
                            <option value="">Select</option>
                            <option value="Employee">Employee</option>
                            <option value="EmployeeAdmin">Admin</option>
                          </select>
                        </div>
                      </div>

                      <div className="col-md-3">
                        <div className="mb-3">
                          <label className="form-label">
                            Department Access{" "}
                            <span className="text-danger">*</span>
                          </label>
                          <select
                            className="form-control"
                            name="departmentAccess"
                            value={formDataAddEmployee.departmentAccess}
                            onChange={handleInputChange}
                          >
                            <option value="">Select</option>
                            <option value="0">No</option>
                            <option value="1">Yes</option>
                          </select>
                        </div>
                      </div>
                      <div className="col-md-3">
                        <div className="mb-3">
                          <label className="form-label">
                            Employee Id <span className="text-danger">*</span>
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            name="emp_id"
                            value={formDataAddEmployee.emp_id}
                            onChange={handleInputChange}
                          />
                        </div>
                      </div>
                      <div className="col-md-3">
                        <div className="mb-3">
                          <label className="form-label">
                            Essl Id <span className="text-danger">*</span>
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            name="essl_id"
                            value={formDataAddEmployee.essl_id}
                            onChange={handleInputChange}
                          />
                        </div>
                      </div>
                      <div className="col-md-12">
                        <div className="mb-3">
                          <label className="form-label">
                            Responsibilities{" "}
                            <span className="text-danger"> *</span>
                          </label>
                          <div className="d-flex align-items-center mb-2">
                            <input
                              type="text"
                              className="form-control me-2"
                              name="responsibility"
                              value={responsibilityInput}
                              onChange={handleResponsibilityInputChange}
                              placeholder="Enter a responsibility"
                            />
                            <button
                              type="submit"
                              className="btn btn-sm btn-primary"
                            >
                              Add
                            </button>
                          </div>
                          {formDataAddEmployee.responsibilities.length > 0 && (
                            <div className="mt-2">
                              <strong>Current Responsibilities:</strong>
                              <ul className="list-unstyled mb-0">
                                {formDataAddEmployee.responsibilities.map(
                                  (responsibility: string, index: number) => (
                                    <li
                                      key={index}
                                      className="d-flex align-items-center mb-1"
                                    >
                                      <span className="badge bg-light text-dark me-2">
                                        {responsibility}
                                        <button
                                          type="button"
                                          className="btn btn-link text-danger p-0 ms-2"
                                          onClick={() =>
                                            handleResponsibilityRemove(
                                              responsibility
                                            )
                                          }
                                        >
                                          <i className="ti ti-x" />
                                        </button>
                                      </span>
                                    </li>
                                  )
                                )}
                              </ul>
                            </div>
                          )}
                        </div>
                      </div>
                      <div className="col-md-3">
                        <div className="mb-3">
                          <label className="form-label">Work From</label>
                          <select
                            className="form-control"
                            name="is_work_from"
                            value={
                              formDataAddEmployee.is_work_from !== null
                                ? formDataAddEmployee.is_work_from
                                : ""
                            }
                            onChange={handleInputChange}
                          >
                            <option value="">Select Option</option>
                            {workFromOptions.map((option: any) => (
                              <option key={option.value} value={option.value}>
                                {option.label}
                              </option>
                            ))}
                          </select>
                        </div>
                      </div>

                      <div className="col-md-3">
                        <div className="mb-3">
                          <label className="form-label">
                            Biometric Access{" "}
                          </label>
                          <select
                            className="form-control"
                            name="is_biometric_enable"
                            value={
                              formDataAddEmployee.is_biometric_enable !== null
                                ? formDataAddEmployee.is_biometric_enable
                                : ""
                            }
                            onChange={handleInputChange}
                          >
                            <option value="">Select Option</option>
                            {biometricOptions.map((option: any) => (
                              <option key={option.value} value={option.value}>
                                {option.label}
                              </option>
                            ))}
                          </select>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="modal-footer">
                    <button
                      type="button"
                      className="btn btn-outline-light border me-2"
                      data-bs-dismiss="modal"
                      id="modal_closed"
                    >
                      Cancel
                    </button>
                    <button
                      type="button"
                      className="btn btn-primary"
                      onClick={handleSubmit}
                    >
                      Save
                    </button>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>

      <EditEmployee
        data={modalData}
        onClose={() => {
          fetchUpdatedRecords();
        }}
      />

      <DeleteModal
        modalId="delete_modal"
        onDelete={handleDelete}
        title="Delete Item"
        message="Are you sure you want to delete this item? This action cannot be undone."
      />

      <UploadModal
        modalId="upload_modal"
        onUpload={uploadSelectedFile}
        selectedFile={selectedFile}
        handleFileUpload={handleFileUpload}
        uploading={uploading}
        documentType={documentType}
        onDocumentTypeChange={handleDocumentTypeChange}
        onModalClose={handleModalClose}
      />

      <UploadModal
        modalId="emp_bulk_share_doc_upload_modal"
        onUpload={handleBulkShare}
        selectedFile={selectedFile}
        handleFileUpload={handleFileUpload}
        uploading={uploading}
        documentType={documentType}
        onDocumentTypeChange={handleDocumentTypeChange}
        onModalClose={handleModalClose}
        filters={bulkUploadFilters}
        onFilterChange={handleBulkUploadFilterChange}
        isBulkUpload={true}
        selectedCount={selectedEmployeeKeys.length}
        allEmployeesData={data}
        allCompanies={getAllCompanyList}
        customTitle={`Bulk Share Document - ${selectedEmployeeKeys.length} selected`}
        onFilteredEmployeesChange={handleFilteredEmployeesChange}
      />

      <ViewDocumentsModal
        modalId="view_documents_modal"
        signature={signature}
        companyId={selectedUserInfo?.companyId || null}
        companyType={selectedUserInfo?.companyType || null}
        userId={selectedUserInfo?.userId || null}
        selectedUserData={selectedUserData || []}
      />

      <EditCredentialsModal
        modalId="edit_credentials_modal"
        onSubmit={handleEditCredentials}
        credentialsForm={editCredentialsForm}
        handleInputChange={handleEditCredentialsInputChange}
      />

      <ToggleLoginModal
        modalId="toggle_login_modal"
        onConfirm={handleToggleLogin}
        isEnabling={selectedCredentialsUser?.LoginEnabled === 0}
      />
      <BulkDocumentsModal
        modalId="bulk_documents_view_modal"
        signature={signature}
        companyId={companyName?.id}
        companyType={companyName?.type}
        allEmployeesData={data}
        allCompanies={getAllCompanyList}
        allDepartments={getDepartmanet}
        allDesignations={getDesignation}
      />

      {/* Filter Panel */}
      <EmployeeFilterPanel
        isOpen={isFilterPanelOpen}
        onClose={() => setIsFilterPanelOpen(false)}
        onApply={handleFilterApply}
        onReset={handleFilterReset}
        initialFilters={filters}
        data={getFilterPanelData()}
      />
    </>
  );
};

export default EmployeeList;
